import React from 'react';
import classNames from 'classnames';
import Text from '../common/src/text/Text';
import '@styles/Banner/phones-banner.scss';

const PhonesBanner = ({ className }) => {
    const classes = classNames('phone-banner alert', className);
    return (
        <div className={classes}>
            <Text as="p">
                Si preferís suscribirte por teléfono, <Text weight="bold">llamanos al 011-5199-4746</Text>. Nuestro horario de atención es de <Text weight="bold">lunes a viernes de 8 a 20hs.</Text>
            </Text>
        </div>
    );
};

export default PhonesBanner;
